/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Select,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  MyButton,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneNews } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import GenerateDescription from "../utils/GenerateDescription";
import { FaHandSparkles } from "react-icons/fa";
import {
  FiImage,
  FiPhone,
  FiShare2,
  FiSettings,
  FiAlignLeft,
  FiFileText,
} from "react-icons/fi";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const news: any = getOneNews();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const news_id = news?.news_id;
  const [title, setTitle] = useState<any>(news?.title);
  const [thumbnail, setThumbnail] = useState<any>(news?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(news?.image_cdn_id);
  const [publishedOn, setPublishedOn] = useState<any>(news?.published_on);
  const [email, setEmail] = useState<any>(news?.email_address);
  const [payLink, setPayLink] = useState<any>(news?.pay_link);
  const [category, setCategory] = useState<any>(news?.category);
  const [phoneNumber, setPhoneNumber] = useState<any>(news?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(news?.whatsapp);
  const [facebook, setFacebook] = useState<any>(news?.facebook);
  const [twitter, setTwitter] = useState<any>(news?.twitter);
  const [instagram, setInstagram] = useState<any>(news?.instagram);
  const [youtube, setYoutube] = useState<any>(news?.youtube);
  const [hashtags, setHashtags] = useState<any>(news?.hashtag);
  const [featured, setFeatured] = useState<any>(news?.featured);
  const [promoted, setPromoted] = useState<any>(
    news?.promoted ? news?.promoted : "no"
  );
  const [newsStatus, setNewsStatus] = useState<any>(news?.status);
  const [description, setDescription] = useState<any>(news?.description);
  const [expo, setExpo] = useState<any>(news?.expo);
  const newsRoutes = "/data/news";
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneNewsHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : news?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level",
      published_on: publishedOn,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      category: category.toString().toLowerCase().replace(/\s/g, "_"),
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_ad: "none",
      country_short: "none",
      status: newsStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
    };

    const { message, status } = await updateOneContent({
      data_id: news_id,
      data: data,
      content: _TYPES_.NEWS,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  return (
    <AddPageShell
      backRoute={newsRoutes}
      eyebrow="DoSee Data • News"
      title="Edit News"
      subtitle={`Update a story relevant to travellers in ${entry_label || "this destination"}.`}
      icon={<FiFileText className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneNewsHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Lead image used in news listings."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.NEWS)}
        />
      </AddSection>

      <AddSection
        title="Story Basics"
        hint="Headline, publish date and category."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <InputField
            props={{
              id: "published_on",
              title: "Published On",
              type: "date",
              value: publishedOn || "",
              onChange: (e: any) => {
                setPublishedOn(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <Select
            props={{
              id: "category",
              title: "Category",
              required: true,
              option: [
                "event",
                "attraction",
                "art",
                "best of africa",
                "book",
                "cinema",
                "city guide",
                "classes",
                "dance",
                "food",
                "getting around",
                "hotel",
                "ministry",
                "movie",
                "museum",
                "music",
                "neighborhood",
                "nightlife",
                "party",
                "restaurant",
                "safari",
                "shopping",
                "theater",
                "things to do",
                "tips and advice",
              ],
              preselect: category
                ? [
                    {
                      name: category
                        .toString()
                        .toLowerCase()
                        .replace("_", " "),
                    },
                  ]
                : [],
              onChange: (e: any) => {
                setCategory(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Contact"
        hint="Optional contact details for the source."
        icon={<FiPhone className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <PhoneInput
            setPhone={setPhoneNumber}
            phone={phoneNumber}
            required={false}
          />
          <InputField
            props={{
              id: "email",
              title: "Email Address",
              type: "email",
              value: email || "",
              onChange: (e: any) => {
                setEmail(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <InputField
            props={{
              id: "pay-link",
              title: "Pay Link (Optional)",
              type: "text",
              value: payLink || "",
              onChange: (e: any) => {
                setPayLink(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Social"
        hint="Public handles related to this story."
        icon={<FiShare2 className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          <InputField
            props={{
              id: "whatsapp",
              title: "Whatsapp",
              type: "text",
              value: whatsapp || "",
              onChange: (e: any) => {
                setWhatsapp(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <InputField
            props={{
              id: "facebook",
              title: "Facebook",
              type: "text",
              value: facebook || "",
              onChange: (e: any) => {
                setFacebook(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <InputField
            props={{
              id: "twitter",
              title: "Twitter",
              type: "text",
              value: twitter || "",
              onChange: (e: any) => {
                setTwitter(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <InputField
            props={{
              id: "instagram",
              title: "Instagram",
              type: "text",
              value: instagram || "",
              onChange: (e: any) => {
                setInstagram(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <InputField
            props={{
              id: "youtube",
              title: "YouTube",
              type: "text",
              value: youtube || "",
              onChange: (e: any) => {
                setYoutube(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Visibility"
        hint="Where this entry shows up across the site."
        icon={<FiSettings className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          <Select
            props={{
              id: "news_status",
              title: "Status",
              option: ["visible", "invisible"],
              preselect:
                newsStatus !== undefined && newsStatus !== null
                  ? [{ name: newsStatus === 1 ? "visible" : "invisible" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setNewsStatus(1);
                else setNewsStatus(0);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <Select
            props={{
              id: "featured",
              title: "Featured",
              option: ["no", "yes"],
              preselect:
                featured !== undefined && featured !== null
                  ? [{ name: featured }]
                  : null,
              onChange: (e: any) => {
                setFeatured(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <Select
            props={{
              id: "promoted",
              title: "Promoted",
              option: ["no", "yes"],
              preselect:
                promoted !== undefined && promoted !== null
                  ? [{ name: promoted }]
                  : null,
              onChange: (e: any) => {
                setPromoted(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
          <Select
            props={{
              id: "gallery",
              title: "Show in Gallery",
              option: ["no", "yes"],
              preselect:
                expo !== undefined && expo !== null
                  ? [{ name: expo === 0 ? "no" : "yes" }]
                  : null,
              onChange: (e: any) => {
                const choice = e.target.value;
                setExpo(choice === "no" ? 0 : 1);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Story"
        hint="Body and tags."
        icon={<FiAlignLeft className="h-4 w-4" />}
        actions={
          <MyButton
            onClick={() => setShowDescriptionModal(true)}
            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-brand to-primary px-3 py-2 text-xs font-semibold text-white shadow hover:opacity-95"
          >
            <FaHandSparkles className="h-4 w-4" />
            Generate
          </MyButton>
        }
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: description || "",
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null as any);
              setSuccess(null as any);
            },
          }}
        />
        <div className="mt-4">
          <InputField
            props={{
              id: "hashtag",
              title: "Tags (comma separated)",
              type: "text",
              value: hashtags || "",
              onChange: (e: any) => {
                setHashtags(e.target.value);
                setError(null as any);
                setSuccess(null as any);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
